import { useEffect, useState } from "react";

const DEFAULT_DELAY = 300;

export default function useDelayOnPropChange(
  prop: any,
  delay: number = DEFAULT_DELAY
) {
  const [delayedProp, setDelayedProp] = useState(prop);

  useEffect(() => {
    const timeout = setTimeout(() => {
      setDelayedProp(prop);
    }, delay);

    return () => clearTimeout(timeout);
  }, [prop, delay]);

  return delayedProp;
}
